import React, { Component } from 'react';
import SharedForm from '../../components/SharedForm';
import { Input, Select } from 'antd';
const { Option } = Select;

const expiryPresets = [3, 7, 14, 30, 90];

const ExpiryInput = ({ value, onChange, id }) => (
  <Input.Group compact>
    <Select value="manual" style={{ width: '42%' }} onChange={preset => {
      if (preset === 'forever') {
        onChange('2099-12-31');
        return;
      }
      const date = new Date();
      date.setDate(date.getDate() + preset);
      const pad = number => String(number).padStart(2, '0');
      onChange(`${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`);
    }}>
      <Option value="manual" disabled>选择时长</Option>
      {expiryPresets.map(days => <Option key={days} value={days}>{days} 天</Option>)}
      <Option value="forever">永久</Option>
    </Select>
    <Input id={id} value={value || ''} onChange={event => onChange(event.target.value)}
      placeholder="YYYY-MM-DD" style={{ width: '58%' }} />
  </Input.Group>
);

const PenaltyTypeSelect = ({ value, onChange, id, disabled }) => (
  <Select id={id} disabled={disabled} value={value ? 'anonymous' : 'mute'}
    onChange={type => onChange(type === 'anonymous')}>
    <Option value="mute">禁言（禁止社区发言和发送私信）</Option>
    <Option value="anonymous">限制匿名（同时禁止发送私信）</Option>
  </Select>
);

export default class BanUserForm extends Component {
  _onSetRef = (ref) => {
    this.props.onSetRef(ref);
  }

  render() {
    const { onSubmit, bannedUser } = this.props;
    const { _id, endDate, isAnom } = bannedUser || {};

    return (
      <SharedForm wrappedComponentRef={this._onSetRef} onSubmit={onSubmit}>
        {{
          formItems: [
            {
              title: '用户 ID',
              name: '_id',
              options: {
                initialValue: _id,
                rules: [{ required: true, message: '请输入用户 ID' }],
              },
              render: () => <Input placeholder="输入用户 ID" readOnly={!!_id} />,
            },
            {
              title: '处罚类型',
              name: 'isAnom',
              options: { initialValue: isAnom === true },
              render: () => <PenaltyTypeSelect disabled={!!endDate} />,
            },
            {
              title: '截止日期',
              name: 'endDate',
              options: {
                initialValue: endDate,
                rules: [
                  { required: true, message: '请选择或输入截止日期' },
                  { pattern: /^\d{4}-\d{2}-\d{2}$/, message: '请输入 YYYY-MM-DD 格式的日期' },
                ],
              },
              render: () => <ExpiryInput />,
            },
            {
              title: '处罚原因',
              name: 'reason',
              options: {
                rules: [{ required: true, whitespace: true, message: '请输入处罚原因' }],
              },
              render: () => <Input.TextArea rows={3} maxLength={500} placeholder="填写本次处罚的原因" />,
            },
          ].map(item => ({ ...item, layout: { labelCol: { span: 24 }, wrapperCol: { span: 24 } } })),
        }}
      </SharedForm>
    );
  }
}
